import React from 'react';
import { FlowBlockButton as BlockModel } from '@staffino/model';
import {
  Box,
  Button,
  buttonFactory,
  StyledButton,
} from '@staffino/primitive-controls';

function calculateStyle(style: string) {
  switch (style) {
    case 'small':
      return { maxWidth: '8rem', px: '0.5rem' };
    case 'medium':
      return { maxWidth: '19rem', px: '1rem' };
    case 'large':
      return { maxWidth: '30rem', px: '3rem' };
    default:
      return { maxWidth: '19rem', px: '3rem' };
  }
}

const Link = StyledButton.withComponent('a');
const LinkButton = buttonFactory(Link);

type Props = {
  block: BlockModel;
  onPress?: () => void;
};
const ButtonBlock = ({ block, onPress }: Props) => {
  const style = calculateStyle(block.buttonStyle);
  const isLink = block.action === 'link';
  const variant = block.buttonStyle === 'link' ? 'link' : 'button';
  const bg = variant === 'link' ? undefined : block?.backgroundColor;

  return (
    <Box padding="1rem">
      <Box alignItems="center">
        {isLink && (
          <LinkButton
            block
            width="100%"
            href={block.url}
            variant={variant}
            target="_blank"
            bg={bg}
            maxWidth={style.maxWidth}
            px={style.px}
            overflowWrap="anywhere"
          >
            {block.label}
          </LinkButton>
        )}
        {!isLink && (
          <Button
            block
            onPress={onPress}
            variant={variant}
            width="100%"
            bg={bg}
            maxWidth={style.maxWidth}
            px={style.px}
            overflowWrap="anywhere"
          >
            {block.label}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ButtonBlock;
